import Grid from '@material-ui/core/Grid'
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = () => ({
  container: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  message: {
    float: 'right',
    color: '#777777',
    marginTop: '10px',
    fontSize: '14px'
  }
})

const Message = ({ classes }) => {
  return (
    <Grid className={classes.container}>
      <div className={classes.message}>
        *Revisa condiciones y promociones en la Revista Mi Natura del ciclo.
      </div>
      <div className={classes.message}>
        **A la ganancia será descontado el IVA.
      </div>
      <div className={classes.message}>
        ***Al ingresar, en tus primeros 4 ciclos tienes la ganancia asegurada del 30%.
      </div>
    </Grid>
  )
}



export const DisclaimerMessage = withStyles(styles)(Message)
